export default {
  userHint: '用户名不正确',
  passwordHint: '密码不正确',
  err: '出错了',
  title: '登录',
  userName: '用户名',
  passWord: '密码',
  hint: '请联系学校管理员重置密码',
  forgetPassword: '忘记密码？',
  login: '立即登录',
  needUserName: '请输入用户名',
  needPassword: '请输入密码',
  cloudRes: '云端资源',
  courseIndex: '云端课程',
  courseMy: '我的课程',
  courseEdit: '创建课程',
  classIndex: '进入课堂',
  ownerCourse: '我的资源',
  // 新版登录页
  loginFuture: '登录未来',
  noAccount: '没有账号？',
  registerNow: '马上注册！',
  registerNotOpen: '暂未开放注册，敬请期待',
  resType: {
    image: '全景图片',
    VR: 'vr课件',
    threeD: '3D模型',
    video: '全景视频'
  },
  subject: {
    Chinese: '语文',
    Math: '数学',
    English: '英语',
    Physics: '物理',
    Chemistry: '化学',
    Biology: '生物',
    History: '历史',
    Geography: '地理',
    Politics: '政治',
    Science: '科学',
    Safe: '安全教育',
  },
  loginInfo: {
    v001: '未来课堂 - 全球领先的',
    v002: 'XR教育云平台',
    v10: '云端课程库 - 构建沉浸式课堂',
    v111: '提高学生',
    v112: '专注度和',
    v113: '认知效果',
    v20: 'XR 教学资源库 - 数量全球第一',
    v21: '教学资源，自由创建个性化的XR课堂',
    v30: '高效的课堂和灵活的系统管理',
    v31: '课堂管控&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;强大省心',
    v32: 'XR课程&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;一键分发',
    v33: '主流终端&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;无缝对接',
    v34: '系统管理&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;弹性灵活',
    v35: '在虚拟课堂中可对所有学生设备进行画面监控、一键静音、远程关机、锁定操作等，让课堂更高效',
    v36: '海量 XR 资源和课程，快速下发到学生设备，同在一个Wi-Fi下时，传输速度更快',
    v37: '跨平台和硬件，三大操作系统，主流硬件无缝切换，让课堂更无界',
    v38: '用户数量自主添加， XR 资源在学生设备上远程安装或卸载，配置学生设备在不同班里中的使用者'
  },

  // ssss
  VCourse: {
    keyword: '关键词',
    reslist: '资源列表',
    goCourse: '去上课',
    addCourse: '加入我的课程',
    editCourse: '编辑课程',
    back: '返回',
    addCourseSuccess: '加入成功，请到我的课程下查看'
  },
  vLangSelect: {
    title: 'VR教学系统',
    default: '简体中文'
  },
  vLogin: {
    userHint: '用户名不正确',
    passwordHint: '密码不正确',
    err: '出错了',
    title: 'VR教学系统',
    userName: '用户名',
    passWord: '密码',
    hint: '请联系学校管理员重置密码',
    forgetPassword: '忘记密码？',
    login: '登录',
    needUserName: '请输入用户名',
    needPassword: '请输入密码'
  },
  vPlayList: {
    PlayList: '播放清单'
  },
  vResItem: {
    returnIndex: '返回主页',
    myCourse: '我的课程',
    exit: '退出',
    return: '返回',
    selectCourseware: '请选择您要添加的课件',
    added: '已添加过',
    addErr: '添加出错',
    enterCourseName: '请输入课程名称',
    enterDateOrTime: '请输入日期或时间',
    enterCourseOrTime: '请输入课程或时间',
    addSuccess: '添加成功',
    addFail: '添加失败',
    coursewareDetail: '课件详情',
    stuControl: '学生端控制',
    title: 'VR教学系统',
    module: '模块',
    screenshot: '截图',
    coreContent: '核心内容',
    duration: '时长',
    control: '控制',
    interaction: '交互',
    joinCourse: '加入课程',
    stuActCard: '学生活动卡',
    notSupportTip: '该资源不支持在一体机设备中播放',
    description: '描述：',
    knowledgeSummary: '本节知识点提要',
    useSuggest: '使用建议',
    selectCourse: '请选择您要添加的课程',
    add: '添加',
    newCourse: '新建课程',
    cancel: '取消',
    courseTitle: '课程名称',
    enterCourse: '请输入课程',
    classTime: '上课时间',
    confirm: '确定',
    viewResult: '您可以在我的课程中查看结果',
    playOrder: '顺序播放',
    processControl: '进程控制',
    voiceExplanation: '语音讲解',
    stare: '凝视',
    click: '点击',
    movePoint: '移动到定点',
    getFail: '获取失败',
    deviceStatus: '学生设备状态：',
    remoteOff: '远程关机',
    cmdMode: '命令模式',
    on: '开',
    off: '关',
    joinCourse2: '加入课程',
    isSwitchModeHint: '确定要切换模式吗？',
    switchModeHint: ['已切换到命令模式', '已切换到自由模式'],
    modeSwitchFail: '模式切换失败',
    selectDevice: '选择设备',
    selectAll: '全选',
    offline: '离线',
    playing: '播放中',
    lowPower: '低电量',
    playCnt: '播放内容',
    pause: '停止播放',
    offHint: '确定要关机吗？',
    operationSuccess: '操作成功',
    operationFailHint: '操作失败，请重试',
    operationFail: '操作失败',
    selectDeviceHint: '请先选择设备',
    playThis: '播放此章节',
    getFailHint: ['获取失败', '请稍后重试'],
    netWorkHint: '网络不通畅，请检查网络',
    appPlayerTip: '请在“班级视图”中获得更好的效果',
    noPlayItem: '请在左侧列表中选择要播放的课件',
    loading: '加载中……',
    joinlist: '加入课程',
    back: '返回',
    chapterlist: '章节列表',
    nomore: '暂无数据',
    explainTitle: '说明：'
  },
  vResList: {
    all: '全部',
    subCharater: '学科属性',
    natureCharater: '自然属性',
    returnIndex: '返回首页',
    title: 'VR教学系统',
    findDream: '找到你的梦想',
    exit: '退出',
    myCourse: '我的课程',
    sysManage: '系统管理',
    search: '搜索',
    type: '类型',
    character: '属性',
    classify: '分类',
    phaseOfStudy: '学段',
    secClassify: '二级分类',
    subject: '学科',
    grade: '年级',
    kenowledgePoint: '知识点',
    books: '册别',
    resourceHint: ['共', '个资源'],
    getFailHint: ['获取失败', '请稍后重试'],
    findTotal: '共找到',
    findRes: '个课程',
    findRes2: '个资源'
  },
  vCourse: {
    all: '全部',
    myCourse: '我的课程',
    returnIndex: '返回首页',
    addCourse: '添加课程',
    exit: '退出',
    enterCourseName: '请输入课程名称',
    enterCourseOrTime: '请输入课程或时间',
    changeSuccess: '修改成功',
    changeFail: '修改失败',
    delTip: '提示',
    delSuccess: '删除成功',
    delClassSuccess: '删除成功',
    enterDateOrTime: '请输入日期或时间',
    title: 'VR教学系统',
    classTime: '上课时间：',
    vrCourseware: 'VR课件',
    video: '视频',
    model: '3D模型',
    removeCourseware: '移除课件',
    addSuccess: '添加成功',
    addFail: '添加失败',
    totalCourse: ['共', '个课程'],
    changeCourse: '修改课程',
    courseTitle: '课程名称：',
    confirm: '确定',
    cancel: '取消',
    newCourse: '新建课程',
    enterCourse: '请输入课程',
    removeCourse: '移除课程',
    delHint: ['课程《', '》删除之后将无法恢复请谨慎操作，'],
    delHints: '是否要删除该课程？',
    removeHint: ['课件《', '》将被移除课程，'],
    removeHints: '移除后可再次从资源库中添加该课件到课程中，',
    removeHintt: '是否继续移除？',
    // -----新增
    inCourseware: '进入课堂',
    alertTitle: '提示'
  },
  vAdmin: {
    all: '系统管理',
    download: '下载管理',
    install: '安装管理',
    accountManage: '账号管理',
    contentManage: '内容管理',
    binding: '人机绑定',
    help: '系统帮助'
  },
  vAccount: {
    vAdmindownload: '下载管理',
    install: '安装明细',
    accountManage: '账号管理',
    accountManange: '账号管理',
    newAccount: '新增账号',
    editAccount: '编辑账号',
    account: '账号',
    nickname: '昵称',
    entNickname: '请输入昵称',
    password: '密码',
    enterPassword: '请输入密码',
    enterHint: '6-20位非空字符',
    fillHint: '不填不修改,',
    confrimPassword: '确认密码',
    repeatPassword: '请重复密码',
    repeatFillHint: '不填不修改，若修改,请重复密码',
    repeatErrHint: '两次密码输入不一致',
    operationSuccess: '操作成功',
    err: '出错了',
    phaseOfStudy: '学段',
    subject: '学科',
    createTime: '创建时间',
    operation: '操作',
    edit: '编辑',
    tipdel: '被删除后将无法恢复，该账号下的所有数据将被清除，',
    tipdel2: '是否仍要删除？',
    del: '删除',
    cancel: '取消',
    getFailHint: ['获取失败', '请稍后重试']
  },
  vInstall: {
    vAdmindownload: '下载管理',
    install: '安装明细',
    accountManage: '账号管理',
    install2: '安装明细',
    installAll: '全部安装',
    operationSuccess: '操作成功',
    gotIt: '知道了',
    operationFailHint: '操作失败，请重试',
    resourceId: '资源ID',
    resourceName: '资源名称',
    resourceCover: '资源封面',
    downloadTime: '下载时间',
    installed: '已安装',
    installing: '安装中',
    uninstall: '未安装',
    installFail: '安装失败',
    operation: '操作',
    viewDetail: '查看详情',
    installHint: ['设备安装情况表（绿色已安装，', '黄色安装中，灰色未安装，红色安装失败）'],
    getFailHint: ['获取失败', '，请稍后重试'],
    devices: '设备列表',

    allInstall: '安装管理',
    alltype: '全部类型',
    allstate: '全部状态',
    needupdate: '需要更新',
    noupdate: '无需更新',
    tipsearch: '请输入关键词搜索课程',
    allupdate: '全部安装',
    alluninstall: '全部卸载',

    yesupdate: '安装确认',
    tipupdate: ['点击安装按钮后，', '课件将安装在未安装该课件的设备上，'],
    tipupdate1: '您可以继续安装或卸载其他课件。',
    btnupdate: '仍要更新',
    cancel: '取消',
    yesuninstall: '卸载确认',
    tipuninstall: '点击卸载按钮后，课件将从已安装的设备上卸载，',
    tipuninstall2: '您可以继续安装或卸载其他课件。',
    plasechose: '请先选择课件',
    confirm: '确认',
    name: '课件名称',
    type: '类型',
    allphaseOfStudy: '全部学段',
    allsubject: '全部学科',
    phaseOfStudy: '学段',
    subject: '学科',
    grade: '年级',
    updateyesorno: '是否有更新',
    no: '否',
    yes: '是',

    btninstall: '安装',
    btnuninstall: '卸载',
    info: '安装详情', // 2019年05月24日修改
    refresh: '刷新',
    refreshDone: '刷新成功',
    refreshFail: '刷新失败',
    // 1.7.2
    viewCourse: '按课件查看',
    viewDevice: '按设备查看',
    back: '返回'
  },
  vStudy: {
    alltype: '请选择班级',
    lesson: '课件名称',
    start: '上课时间',
    end: '结束时间',
    teacher: '上课教师',
    class: '上课班级',
    selectStudent: '选择学生',
    search: '搜索',
    all: '全部',
    test: '评测人数',
    operation: '操作',
    view: '查看数据',
    tipsearch: '请输入课程名称',
    personalAttempt: '个人/班级尝试次数统计',
    personalAttemptNum: '尝试次数',
    averageTimes: '平均次数',
    pointMastery: '考点掌握',
    personalStatistics: '个人考点正/误统计',
    correct: '正确',
    error: '错误',
    empty: '未答',
    timeComparison: '个人/班级各考点时长对比',
    personalTime: '个人用时',
    averageClassTime: '班级平均用时',
    progressDesc: '进度设置说明',
    examinationNotes: '考点说明',
    step: '步骤',
    description: '说明',
    includingTest: '包括考点',
    accuracyRate: '正确率',
    errorRate: '错误率',
    emptyRate: '未答率',
    perNum: '人数',
    learningRating: '学习评级',
    ratingDistribution: '评级分布',
    overallCompletion: '整体完成情况',
    knowledgeMastering: '课程进度及知识掌握',
    processSetup: '流程设置说明',
    pointTestNum: '各考点尝试次数统计',
    maxTest: '最大次数',
    minTest: '最小次数',
    averageTest: '平均次数',
    pointTime: '各考点用时统计',
    maxTime: '最大用时',
    minTime: '最小用时',
    averageTime: '平均用时',
    teachData: '教学数据',
    levelA: 'A级',
    levelB: 'B级',
    levelC: 'C级',
    levelD: 'D级',
    levelOther: '其他',
    minute: '分钟',
    completeNum: '完成人数',
    lessonSet: '课程设置',
    getData: '正在采集数据',
    getDataFinished: '采集完毕，点击查看更多数据',
    studyData: '学习数据',
    pointsCount: '各考点正确率统计',
    xAxisText: '步骤-考点',
    cNum: '次数',
  },
  vDownload: {
    vAdmindownload: '下载管理',
    install: '安装明细',
    accountManage: '账号管理',
    toBeDownload: '待下载',
    downloaded: '已下载',
    chooseHint: '请先选择',
    err: '出错了',
    name: '名称',
    download: '下载',
    downloadToServer: '下载至服务器',
    size: '大小',
    downloadStartTime: '下载开始时间',
    status: '状态',
    operation: '操作',
    retry: '重试',

    refreshStatus: '刷新下载状态',
    getFailHint: ['获取失败', '，请稍后重试']
  },
  vContent: {
    content: '内容管理',
    alltype: '全部类型',
    allstate: '全部状态',
    needupdate: '需要更新',
    noupdate: '无需更新',
    tipsearch: '请输入关键词搜索资源',
    tipsearch2: '请输入关键词搜索课程',
    allupdate: '全部更新',
    yesupdate: '更新确认',
    tipupdate: '为了不影响使用，请勿在上课期间进行更新，',
    tipupdate1: '同时请确保所有设备都已开机。',
    btnupdate: '仍要更新',
    save: '保存',
    cancel: '取消',
    yesuninstall: '卸载确认',
    tipuninstall: '点击卸载按钮后，课件将从已安装的设备上卸载，',
    tipuninstall2: '您可以继续安装或卸载其他课件。',
    confirm: '确认',
    name: '课件名称',
    type: '类型',
    allphaseOfStudy: '全部学段',
    allsubject: '全部学段',
    phaseOfStudy: '学段',
    subject: '学科',
    grade: '年级',
    updateyesorno: '是否有更新',
    no: '否',
    yes: '是',
    operation: '操作',
    update: '更新',
    edit: '编辑',
    refresh: '刷新',
    refreshDone: '刷新成功',
    refreshFail: '刷新失败',
    plasechose: '请选择学段'
  },
  vBinding: {
    classlist: '班级列表',
    classname: '班级名称',
    classnum: '绑定设备数',
    creattime: '创建时间',
    newclass: '新建班级',
    editclass: '编辑班级',
    bindingstudent: '绑定学生',
    delcalss: '删除班级',
    devicenum: '设备编号',
    mac: 'MAC码',
    studentname: '学生姓名',
    handle: '操作',
    editbinding: '编辑绑定',
    delbinding: '解除绑定',
    bindinglist: '批量解绑',
    refresh: '刷新',
    refreshDone: '刷新成功',
    refreshFail: '刷新失败',
    // 2019年05月20日新增
    titname: '人机绑定',
    edittitname: '人机绑定-绑定学生',

    tipclassname: '请输入班级名称',
    tipstudentname: '请输入学生姓名',
    operationSuccess: '操作成功',
    btnsave: '保存',
    btnyes: '确定',
    btndel: '删除',
    btnunbind: '解除',
    btncancel: '取消',
    tipunbind1: '是否确定解除设备',
    tipunbind2: '与学生',
    tipunbind3: '的绑定关系?',
    plasechose: '请先选择设备',
    delclasstip1: '班级删除后，绑定的学生数据将被清除且不可恢复,',
    delclasstip2: '是否继续删除?'
  },
  play: {
    hint: '轻触空白处关闭'
  },
  vAccountForm: {
    edit: '编辑',
    newAccount: '新建账号',
    save: '保存',
    cancel: '取消',
    account: '账号',
    enterAccount: '请输入账号',
    accountHint: '数字、字母、下划线，4-30位',
    nickname: '昵称',
    enterNickname: '请输入昵称',
    password: '密码',
    enterPassword: '请输入密码',
    passwordHint: '6-20位非空字符',
    modifyHint: ['不填不修改，', '若修改'],
    confirmPassword: '确认密码',
    repeatPassword: '请重复密码',
    checkPassword: '两次密码输入不一致',
    operationSuccess: '操作成功',
    err: '出错了',
    phaseOfStudy: '学段',
    subject: '学科',
    pleasechoose: '请选择'
  },
  uHeader: {
    homePage: '首页',
    returnIndex: '返回首页',
    title: 'VR教学系统',
    placeHolder: '输入关键词搜索',
    search: '搜索',
    sysManage: '系统管理',
    myCourse: '我的课程',
    addCourse: '添加课程',
    exit: '退出系统',
    // -----新增
    changeName: '修改名字',
    inputName: '请输入你的名字',
    password: '密码',
    passwordHint: '6-20位非空字符',
    oldPassword: '请输入旧密码',
    enterPassword: '请输入新密码',
    changePwd: '修改密码',
    confirmPassword: '确认密码',
    repeatPassword: '请再次输入新密码',
    checkPassword: '两次密码输入不一致',
    operationSuccess: '操作成功',
    save: '保存',
    cancel: '取消',
    err: '出错了',
    CloudLibrary: '云端库',
    mylist: '我的清单',
    Playbackcontrol: '播放控制',
    Classview: '班级视图',
    installInfo: '安装详情',
    exitclass: '退出课堂',
    back: '返回',
    siteName: '未来课堂'
  },

  vsider: {
    playlist: '播放课程',
    save: '保存课程',
    sendout: '发送资源',
    del: '清空课程',
    nofind: '找不到',
    noth: '没有',
    addsuccess: '添加成功',
    readd: '课程已添加',
    siderlinulltip1: '请将右侧资源拖动到此处',
    siderlinulltip2: '创建你的播放清单',
    saveaslist: '保存课程',
    saveaslistfail: '保存课程失败',

    tipaddtolist: '请先添加课件到播放清单',
    tipsavelist: '请输入列表名称',
    tipmore: '最多20字',
    btnsave: '保存',
    btnyes: '确定',
    btncancel: '取消',
    save2: '保存',
    cancel: '取消',
    createnewcourse: '创建新的课程',
    savetocourse: '保存到已有课程',
    choosecourse: '请选择课程',
    saveplaylist: '保存清单',
    clearplaylist: '清空清单',

    sendingresources: '发送资源',
    sendingresourcestip1: '列表中的资源正在向所选设备发送,',
    sendingresourcestip2: '你可以在设备状态中查看进度',
    claerlist: '清空列表',
    claerlisttip: '列表清空后,可以继续添加资源到列表',

    tipchosedevice: '请先选则设备',
    changeok: '切换成功',
    setok: '设置成功',
    handle: '操作',
    name: '名称',
    choseclass: '点击选择班级',
    openoroff: '打开/关闭控制模式',
    synchronouspicture: '同步画面',
    Mute: '开启/静音',
    close: '关闭',

    explainPlaceholder: '请在此输入说明',
    explainPlaceholder2: '请输入新的说明',
    clickToEdit: '点击即可编辑',
    explainTitle: '说明',
    noExplain: '暂无说明',
    noplayALL: '未保存的课程',
    saveList: '保存课程',
    sendRes: '发送资源',
    clearList: '清空课程',
    editList: '编辑课程',
    delConfirm: '确定',
    clear: '清空'
  },
  // 播控页
  playCtro: {
    saveList: '保存课程',
    sendRes: '发送资源',
    clearList: '清空课程',
    empty: '空空如也~',
    // 编辑课程
    editList: '编辑课程',
    pleaseInputEditListName: '请输入课程名称',
    editDone: '编辑成功',
    // 删除课程
    delPlayListTip: '该课程将被删除请确认',
    delPlayList: '删除课程',
    delDone: '删除成功',
    btnyes: '确定',
    btncancel: '取消',
    saveAsList: '存为课程',
    saveaslist: '保存课程',
    saveaslistfail: '保存课程失败',
    okText: '保存',
    pleaseInputListName: '请输入课程名称',
    max20: '最多20字',
    all: '全部',
    checkAsList: '请选择课程',
    saveAsOldList: '保存到已有课程',
    saveAsNewList: '创建新的课程',
    sentListTip: '发送即将开始。请确保所有目标设备都已打开。建议连接同一个WiFi，以获得更高的数据传输速度。',
    sendListTipConfrim: '发送资源',
    resSending: '列表中的资源正在向所选设备发送，你可以在设备状态中查看进度',
    resSendDone: '发送成功',
    // 班级视图
    loading: '加载中...',
    nomore: '暂无在线设备，请确保设备正常联网后刷新页面查看。',
    reloadImg: '加载失败,点击重试',
    installed: '已安装',
    installing: '安装中',
    uninstalled: '未安装',
    installFailed: '安装失败',
    InstallationAgain: '再次安装',
    selectClass: '选择班级',
    openControlMode: '控制模式：关',
    offControlMode: '控制模式：开',
    syncFrame: '同步画面',
    openVoice: '静音模式：开',
    mute: '静音模式：关',
    shutdown: '关机',
    pleaseSelectDevice: '请先选择设备',
    noPrevious: '没有上一个',
    noNext: '没有下一个',
    syncSuccess: '同步成功',
    switchedToControlMode: '已切到控制',
    switchedToFreeMode: '已切到自由',
    voiceOn: '已开启声音',
    muted: '已静音',
    shutdownSuccess: '操作成功',
    shutdownTips: '你确定要将所有设备关机吗？',
    noDeviceOnline: '当前没有设备在线'
  },

  // 资源上传
  resource: {
    resource: '资源管理',
    cloudSpace: '云盘空间：',
    baseInfo: '资源基本信息',
    choseResource: '选择文件：',
    require: '必填',
    noRequire: '选填',
    noFile: '无',
    loadingVideo: '正在上传视频资源',
    loadingImage: '正在上传全景图片资源',
    loadingModel: '正在上传3D模型资源',
    modelUpload: '3D模型上传成功',
    currentResource: '当前资源',
    dragResource: '请点击或将媒体文件拖放到此区域开始上传。',
    format: '格式支持：',
    videoType: '视频类型',
    screenVidoe: '球面全景视频',
    normalVideo: '2D平面视频',
    videoRule: '必选，如果您不能确定视频类型，请根据预览画面切换视频类型。',
    screenImg: '全景图片格式：.png，.jpg，.jpeg；',
    video: '视频格式：.mp4；（全景视频仅支持球面类型的全景视频）；',
    model: '3D模型格式：.gltf，.zip',
    cover: '封面图：',
    uploadingCover: '正在上传封面',
    currentCover: '当前封面',
    dragCover: '请点击或将封面图拖放到此区域开始上传。',
    coverFormat: '格式：.png，.jpg，.jpeg；',
    resolution: '分辨率：不超过1920*1080；',
    resourceName: '资源名称：',
    resourceNameRule: '必填，最多80字。',
    resourcePoint: '知识点：',
    resourcePointRule: '选填，最多600字。可以在此描述该资源涉及的知识点。',
    resourceDesc: '资源描述：',
    resourceDescRule: '选填，最多600字。可以在此描述该资源整体的描述。',
    resourceLable: '资源标签：',
    resourceLableRule: '选填，最多80字。资源标签可用于关键词搜索，如有多个标签，请用逗号隔开。',
    subject: '学科：',
    subjectRule: '选填，学科可用于按分类搜索。',
    primary: '小学：',
    middle: '中学：',
    chinese: '语文',
    math: '数学',
    english: '英语',
    physics: '物理',
    chemistry: '化学',
    biology: '生物',
    resourceId: '资源ID',
    resourceType: '资源类型',
    updater: '上传人',
    dataSize: '文件大小',
    updateTime: '上传时间',
    refreshTime: '更新时间',
    operation: '操作',
    addResource: '新增资源',
    download: '下载',
    edit: '编辑',
    delete: '删除',
    deleteTip: '资源删除后将不可恢复，你确定要删除吗',
    btnyes: '删除',
    btnno: '取消',
    deleteTitle: '删除',
    listCover: '封面图',
    listName: '资源名称',
    readAndAgree: '我已阅读并同意',
    updateRule: '《XR教育云平台资源上传规则》。',
    save: '保存',
    cancel: '取消',
    noResource: '没有选择资源，请选择要上传的资源。',
    resourceUpdating: '资源正在上传中，请耐心等候。',
    wrongData: '不支持的文件类型，请重新选择',
    outsizeData: '云盘空间不足，无法上传。',
    muchData: '不支持多个文件上传，请重新选择。',
    emptyName: '资源名称不能为空。',
    no: '无',
    xrUpdateRule: 'XR教育云平台资源上传规则',
    uploadAlready: '该文件已上传完毕，无需再次上传。',
    hasUploaded: '已上传',
    noneUploaded: '未上传'
  },
  uploadRule: {
    ruleTitle: 'XR教育云平台资源上传规则',
    rule: {
      rule0: '一、用户在使用XR教育云平台的产品与/或服务过程中，应遵守法律、法规，应遵守公共秩序，尊重社会公德，不得危害网络安全，不得利用网络从事危害国家安全、荣誉和利益，煽动颠覆国家政权、推翻社会主义制度，煽动分裂国家、破坏国家统一，宣扬恐怖主义、极端主义，宣扬民族仇恨、民族歧视，传播暴力、淫秽色情信息，编造、传播虚假信息扰乱经济秩序和社会秩序，以及侵害他人名誉、隐私、知识产权和其他合法权益等活动。在任何情况下，XR教育云平台一旦合理地认为用户存在上述行为的，可以在任何时候，不经事先通知终止向该用户提供产品与/或服务。',
      rule1: '二、禁止用户利用XR教育云平台提供的产品和服务从事以下行为：',
      rule2: '1.制作、上传、复制、传送、传播包含任何反对宪法所确定的基本原则、危害国家安全、泄露国家秘密、颠覆国家政权、破坏国家统一、破坏民族团结、损害国家荣誉和利益、煽动民族仇恨、民族歧视、破坏民族团结、破坏国家宗教政策、宣扬邪教和封建迷信、淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪、侮辱或者诽谤他人，侵害他人合法权益的等法律、行政法规禁止的内容或其他另人反感的包括但不限于资讯、资料、文字、软件、音乐、照片、图形、信息或其他资料；',
      rule3: '2.以任何方式危害未成年人；',
      rule4: '3.冒充任何人或机构，或以虚伪不实的方式谎称或使人误认为与任何人或任何机构有关；',
      rule5: '4.伪造标题或以其他方式操控识别资料，使人误认为该内容为XR教育云平台所传送；',
      rule6: '5.将无权传送的内容（例如内部资料、机密资料）进行上载、张贴、发送电子邮件或以其他方式传送；',
      rule7: '6.将侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容加以上载、张贴、发送电子邮件或以其他方式传送；',
      rule8: '7.用户需保证其上传内容不得含有以下内容：',
      rule9: '（一）反对宪法确定的基本原则的；',
      rule10: '（二）危害国家统一、主权和领土完整的；',
      rule11: '（三）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；',
      rule12: '（四）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；',
      rule13: '（五）宣扬邪教、迷信的',
      rule14: '（六）扰乱社会秩序，破坏社会稳定的；',
      rule15: '（七）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；',
      rule16: '（八）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；',
      rule17: '（九）危害社会公德，损害民族优秀文化传统的；',
      rule18: '（十）有关法律、行政法规和国家规定禁止的其他内容。',
      rule19: '如用户提供的上传内容含有以上违反政策法律法规的信息或者内容的，由用户直接承担以上导致的一切不利后果，如因此给XR教育云平台造成不利后果的，用户应负责消除影响，并且赔偿因此导致的一切损失',
      rule20: '三、用户使用XR教育云平台的产品与/或服务在XR教育云平台制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的，应保证其上传内容不违反使用当地的法律法规及相关规范性文件，亦不侵犯任何第三方的合法权益，否则导致的一切不利后果均由用户自行承担，造成XR教育云平台损失的，还应向XR教育云平台承担赔偿责任。对于相关权利人因用户违反本款约定向XR教育云平台主张权利的，XR教育云平台有权不通知上传用户直接删除、下线、屏蔽相关争议内容。',
      rule21: '四、用户对其利用XR教育云平台服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容的行为，独立完整地承担法律责任，包括如造成XR教育云平台损失的，应向XR教育云平台承担赔偿责任。同时：',
      rule22: '1.为了维护用户使用XR教育云平台服务地区的法律法规及相关规范性文件、保护他人的合法权益、维护XR教育云平台的信誉及安全，XR教育云平台有权直接删除用户利用XR教育云平台产品与/或服务制作、上传、发布、传播的符号、文字、图片、音频、视频等内容，而无需事先通知用户；',
      rule23: '2.XR教育云平台的后台记录有可能作为用户违反法律法规、违约、侵权的证据。',
      rule24: '3.用户应当保证，不会利用XR教育云平台服务或其衍生服务侵犯XR教育云平台以及他人的合法权益，禁止通过网络漏洞、恶意软件或其他非法手段破坏XR教育云平台的正常经营，窃取、盗用他人的账号及账号下财产等；禁止侵犯他人合法权益的其他内容。否则，XR教育云平台有权根据情节严重而对该用户及用户账号进行冻结、封号等处理。构成犯罪的，XR教育云平台有权移交有权部门处理。'
    }
  },
  vStudentList: {
    stuMenage: '学生管理',
    studentCreate: '新建学生',
    studentLabel: '请输入学生名称',
    studentTips: '学生姓名不可为空',
    stuNumTip1: '请输入唯一的纯数字学号',
    stuNumTip2: '请输入唯一学号',
    stuNumTip3: '必须为纯数字',
    classEdit: '班级编辑',
    classStu: '班级学生',
    stuNum: '学生数',
    editName: '编辑名称',
    stuNameTip1: '请输入学生姓名',
    stuNameTip2: '学生姓名不可为空',
    stuNumText: '学号',
    uploadTip1: '请上传文件',
    uploadTip2: '选择文件',
    downLoad: '点击下载',
    downExample: '导入模板',
    stuName: '姓名',
    stuNumber: '学号',
    importExcel: '导入',
    exportExcel: '导出',
    editStudent: '编辑',
    removeStudent: '移出学生',
    stuIndex: '序号',
    stuName2: '学生名称',
    example: '示例',
    classCreate: '新建班级',
    classDelete: '删除班级',
    className: '班级名称',
    removeOther: '移出到其他班级',
    removeToClass: '移动到班级：',
    resolve: '有效',
    messageErr: '信息有误',
    stuNumberRule1: '输入学号时，请保证学生学号为校内唯一的纯数字',
    status: '状态',
    confirmStudentInfo: '确认上传学生信息',
    totalStudent: '本次上传学生信息数：',
    rightStudent: '有效信息数：',
    wrongStudent: '错误信息数：',
    selectClass: '请选择本次上课选项',
    selectClassLabel: '选择当前上课班级：',
    selectClientGroup: '请选择设备组：',
    selectLearnClass: '请选择上课班级',
    fileFormatWrong: '文件格式错误，请上传xls，xlsx格式文件',
    tableWrong: '未检测到目标字段，请使用提供的模板上传信息'
  },
  vClients: {
    person: '人',
    finishNumLabel: '完成测验人数',
    currentNumLabel: '当前测验人数',
    unStartLabel: '尚未进行测验人数',
    testStudentRate: '测验学生评级分布',
    studentRate: '评级分布',
    studyPointTitle: '课程知识点整体掌握情况',
    createGroup: '新建分组',
    edit: '编辑',
    clients: '设备',
    deleteGroup: '删除分组',
    groupName: '分组名称',
    editGroup: '编辑分组',
    deleteGroupTip1: '删除分组后，该分组内绑定的设备将恢复为未绑定状态',
    deleteGroupTip2: '确认要删除吗？',
    clientGroup: '设备组',
    clientNum: '设备数',
    remove: '解除',
    bind: '添加',
    clientId: '设备编号',
    clientMac: '设备唯一码',
    status: '状态',
    rating: '进行中',
    unrating: '未进行',
    studentControl: '学生的知识点掌握情况',
    learnList: '知识点明细',
    controlInfo: '掌握情况',
    finishClass: '下课',
    finishClassAndShutDown: '确定要结束本次课程吗？',
    finishShutDown: '全部关机并下课',
    finishShutDownTip1: '确定结束本次课程吗？',
    loginOutTip1: '这可能会中断该学生的正常操作',
    loginOutTip2: '是否确认在该设备内登出该学生？',
    loginOutTip3: '登出学生',
    holding: '进行中',
    noTest: '暂无测评成绩',
    clientsSet: '设备管理',
    notLoginStudent: '未上线学生',
    noClassStudent: '(非本班学生)'
  }
}
